export default __webpack_public_path__ + "static/media/logo-tesauro-ssoc.f97702a4.png";